export default function slugify(str) {
  return str.replaceAll(' ', '-').toLowerCase();
}
